import "./index.scss";
import React from "react";

class Radio extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;

        const handleChange = () => {
            if(props.onChange) {
                props.onChange(props.value);
            }
        }

        return (
            <div class={`radioItem ${props.checked ? "active" : ""}`} onClick={handleChange}>
                {props.checked && <span class="activeState"></span>}
            </div>
        )
    }
}

Radio.defaultProps = {
    checked: false
}

export default Radio;